import { createStore, applyMiddleware, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { rootEpic, rootReducer } from "./modules";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import env from "src/core/env";

const epicMiddleware = createEpicMiddleware();

const persistConfig = {
  key: env.APP_NAME + "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore() {
  const store = createStore(
    persistedReducer,
    compose(
      applyMiddleware(epicMiddleware)
      // (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
      //   (window as any).__REDUX_DEVTOOLS_EXTENSION__()
    )
  );
  const persistor = persistStore(store);

  epicMiddleware.run(rootEpic);

  return { store, persistor };
}
